import i18n from "i18next";

const exportUsersAsCsv = {
  headers() {
    i18n.loadNamespaces("translation");

    return [
      {
        label: i18n.t("userList.tableHeader.username"),
        key: "username",
      },
      { label: i18n.t("userList.tableHeader.name"), key: "name" },
      { label: i18n.t("userList.tableHeader.surname"), key: "surname" },
      { label: i18n.t("userList.export.active"), key: "active" },
      { label: i18n.t("userList.tableHeader.address"), key: "address" },
      { label: i18n.t("userList.tableHeader.city"), key: "city" },
      { label: i18n.t("userList.tableHeader.roles"), key: "roles" },
      {
        label: i18n.t("userList.tableHeader.country") + " (ISO 3166-1 Alpha2)",
        key: "country",
      },
      {
        label: i18n.t("userList.tableHeader.company"),
        key: "company_name",
      },
      { label: i18n.t("userList.export.salutation"), key: "salutation" },
      { label: i18n.t("userList.export.title"), key: "title" },
      { label: i18n.t("userList.tableHeader.phone"), key: "phone" },
      { label: i18n.t("userList.tableHeader.zipcode"), key: "zipcode" },
      { label: i18n.t("userList.tableHeader.address"), key: "address" },
      { label: i18n.t("userList.tableHeader.email"), key: "email" },
      { label: i18n.t("userList.editModal.registerdAt"), key: "register_date" },
      { label: i18n.t("userList.editModal.lastActive"), key: "lastActiveAt" },
    ];
  },

  export(users) {
    if (!users) {
      return [];
    }

    return users.map((val) => {
      return {
        active: val.active,
        address: val.address,
        city: val.city,
        roles: Object.getOwnPropertyNames(val.roles),
        name: val.name,
        surname: val.surname,
        country: val.country,
        company_name: val.company_name,
        salutation: val.salutation,
        title: val.title,
        phone: val.phone,
        zipcode: val.zipcode,
        email: val.email,
        username: val.username,
        register_date: val.createdAt,
        lastActiveAt: val.lastActiveAt,
      };
    });
  },
};

export default exportUsersAsCsv;
